import { 
	QueryResult,
	SearchBlockType
} from "../../typings"; 
import Tooltip from "../Tooltip";

export default class SuggestionEntry {
	private prefixSpan: JQuery;
	private searchSpan: JQuery;
	private otherSpan: JQuery;
	private spanContainer: JQuery;
	private searchText: string;
	private term: QueryResult;
	private tooltip: Tooltip;
	private synonyms: string;
	private static libPrefixSeparator = ": ";
	private static edsPrefix = "(EDS) ";

	constructor(button: JQuery, term: QueryResult) {
		const text = term.DisplayName || term.Name;
		this.term = term;
		this.button = button;
		this.searchText = text;

		this.spanContainer = $("<span>").addClass("option-text");

		this.prefixSpan = $("<span>");
		this.searchSpan = $("<span>").addClass("option-text-highlighted");
		this.otherSpan = $("<span>");

		this.otherSpan.text(this.searchText);

		this.button.append(this.spanContainer);

		this.spanContainer
			.append(this.prefixSpan)
			.append(this.searchSpan)
			.append(this.otherSpan);

		if (this.term.Type === SearchBlockType.Synonym ||
			this.term.Type === SearchBlockType.Descriptor) {
			this.synonyms = term.Synonyms.length ? 
				normalizeText(term.Synonyms.join("; ")) 
				: GlobalSearchLabels.ThereAreNoSynonyms;

			this.tooltip = new Tooltip(this, false, "right", true);
			this.container
				.on("mouseover", event => 
					this.tooltip.toggleVisibility(event))
				.on("mouseout", event => 
					this.tooltip.toggleVisibility(event));
		}
	}

	public button: JQuery;
	public get container(): JQuery {
		return this.spanContainer;
	}

	public dispose(): void {
		this.tooltip?.dispose();
	}
		
	public getTooltipInfo(): JQuery {
		const bag = {};
		bag[GlobalSearchLabels.MainTopicName] = this.term.Name; 
		bag[GlobalSearchLabels.Synonyms] = this.synonyms;

		const content = $("<div>")
			.addClass("tooltip-container");
		
		for (const i in bag) {
			content.append($("<div>")
				.addClass("rup-global-search__tooltip-suggestion")
				.append($("<span>")
					.addClass("rup-caption-strong")
					.append(`${i}: `))
				.append($("<span>")
					.addClass("rup-caption")
					.append(bag[i])));
		}

		return content;
	}

	public getTooltipInfoExtended(): [JQuery, JQuery] {
		const bag = {};
		bag[GlobalSearchLabels.MainTopicName] = this.term.Name; 
		bag[GlobalSearchLabels.Vocabulary] = this.term.Vocab;

		const header = $("<h1>").text(this.term.Value);

		const content = $("<div>")
			.addClass("tooltip-container");
		
		for (const i in bag) {
			content.append($("<div>")
				.append($("<span>")
					.addClass("rup-caption")
					.append(`${i}: `))
				.append($("<span>")
					.addClass("rup-caption-strong")
					.append(bag[i])));
		}
	
		content.append($("<div>")
			.css("margin-top", "1rem")
			.append($("<span>")
				.addClass("rup-caption-strong")
				.append(GlobalSearchLabels.Synonyms))
			.append($("<span>")
				.addClass("rup-caption")
				.append(`: ${this.synonyms}`)));
		
		return [header, content];
	}

	public highlight(text: string): void {
		let partToMatch = this.searchText.substring(0, text.length);
		if (partToMatch.localeCompare(
			text, undefined, { sensitivity: 'accent' }) === 0) {
			this.searchSpan.text(partToMatch);
			this.otherSpan.text(this.searchText.substring(text.length));
			return;
		}

		for (const sep of 
			[SuggestionEntry.libPrefixSeparator, SuggestionEntry.edsPrefix]) {
			let sepStarts = this.searchText.indexOf(sep);
		
			if (sepStarts === -1) {
				continue;
			}

			sepStarts += sep.length;
			partToMatch = this.searchText.substring(sepStarts, sepStarts + text.length);
			if (partToMatch.localeCompare(
				text, undefined, { sensitivity: 'accent' }) === 0) {
				this.prefixSpan.text(this.searchText.substring(0, sepStarts));
				this.searchSpan.text(partToMatch);
				this.otherSpan.text(this.searchText.substring(sepStarts + text.length));
				break;
			}
		}
	} 
}


